export const tableControls = [
  { id: "scfControl", type: "text", label: "Controle", sortable: true },
  { id: "scfDomain", type: "dropdown", label: "Domínio", sortable: true },
  { id: "controlWeighting", type: "number", label: "Peso do Controle", sortable: true },
  { id: "status", label: "Status", type: "status"},
  { id: "maturity_level", label: "Nível de Maturidade", type: "maturity-level" },
];
